/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Override_Membership_Start_DateInputs */

const en_admin_allocation_form_override_membership_start_date = /** @type {(inputs: Admin_Allocation_Form_Override_Membership_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Override membership start date`)
};

const de_admin_allocation_form_override_membership_start_date = /** @type {(inputs: Admin_Allocation_Form_Override_Membership_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum der Mitgliedschaft überschreiben`)
};

const es_admin_allocation_form_override_membership_start_date = /** @type {(inputs: Admin_Allocation_Form_Override_Membership_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrescribir fecha de inicio de la suscripción`)
};

const fr_admin_allocation_form_override_membership_start_date = /** @type {(inputs: Admin_Allocation_Form_Override_Membership_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer la date de début de l'abonnement`)
};

/** @type {(inputs: Admin_Allocation_Form_Override_Membership_Start_DateInputs) => LocalizedString} */
const it_admin_allocation_form_override_membership_start_date = en_admin_allocation_form_override_membership_start_date;

/** @type {(inputs: Admin_Allocation_Form_Override_Membership_Start_DateInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_override_membership_start_date = en_admin_allocation_form_override_membership_start_date;

/** @type {(inputs: Admin_Allocation_Form_Override_Membership_Start_DateInputs) => LocalizedString} */
const pl_admin_allocation_form_override_membership_start_date = en_admin_allocation_form_override_membership_start_date;

/** @type {(inputs: Admin_Allocation_Form_Override_Membership_Start_DateInputs) => LocalizedString} */
const hu_admin_allocation_form_override_membership_start_date = en_admin_allocation_form_override_membership_start_date;

/** @type {(inputs: Admin_Allocation_Form_Override_Membership_Start_DateInputs) => LocalizedString} */
const ro_admin_allocation_form_override_membership_start_date = en_admin_allocation_form_override_membership_start_date;

/**
* | output |
* | --- |
* | "Override membership start date" |
*
* @param {Admin_Allocation_Form_Override_Membership_Start_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_override_membership_start_date = /** @type {((inputs?: Admin_Allocation_Form_Override_Membership_Start_DateInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Override_Membership_Start_DateInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_override_membership_start_date(inputs)
	if (locale === "de") return de_admin_allocation_form_override_membership_start_date(inputs)
	if (locale === "es") return es_admin_allocation_form_override_membership_start_date(inputs)
	if (locale === "fr") return fr_admin_allocation_form_override_membership_start_date(inputs)
	if (locale === "it") return it_admin_allocation_form_override_membership_start_date(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_override_membership_start_date(inputs)
	if (locale === "pl") return pl_admin_allocation_form_override_membership_start_date(inputs)
	if (locale === "hu") return hu_admin_allocation_form_override_membership_start_date(inputs)
	return ro_admin_allocation_form_override_membership_start_date(inputs)
});
export { admin_allocation_form_override_membership_start_date as "admin.allocation_form.override_membership_start_date" }